/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ProjectRouteAddedDtoBase
 * auto generated base class for the model ProjectRouteAddedDtoModel.
 *
 * Read only view event
 */
export const ProjectRouteAddedDtoModelBase = ModelBase
  .named('ProjectRouteAddedDto')
  .props({
    __typename: types.optional(types.literal("ProjectRouteAddedDto"), "ProjectRouteAddedDto"),
    routeId: types.union(types.undefined, types.string),
    /** Route driver's name */
    name: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ProjectRouteAddedDtoModelSelector extends QueryBuilder {
  get routeId() { return this.__attr(`routeId`) }
  get name() { return this.__attr(`name`) }
}
export function selectFromProjectRouteAddedDto() {
  return new ProjectRouteAddedDtoModelSelector()
}

export const projectRouteAddedDtoModelPrimitives = selectFromProjectRouteAddedDto().routeId.name
